import { CommunicationResponseModel, ProviderModel } from '@/app/shared/models';
import { HttpService } from '@/app/shared/services/http.service';
import { env } from '@/environments';
import { NotifyType } from '@/app/shared/enums/notify/notify-type.enum';

export class NotifyService extends HttpService {
  public async GetCommunications(data: {
    campaignId: string;
    communicationId: string;
    queryParams?: Record<string, string>;
  }): Promise<CommunicationResponseModel[]> {
    const queryString = data.queryParams
      ? '?' + new URLSearchParams(data.queryParams).toString()
      : '';

    return await this.get<CommunicationResponseModel[]>(
      `${env.notifyUri}/campaigns/${data.campaignId}/communications/${data.communicationId}/customer${queryString}`
    ).then(({ data }) => data);
  }

  public async SendMessage(data: {
    Type: string;
    Content: string;
    Recipient: string;
    Subject: string;
    Origin: string;
    OriginId: string;
    Provider?: string;
    Priority?: string;
    Scheduled?: string;
    MerchantKey: string;
  }): Promise<{ ok: true }> {
    data.Priority = 'Low';
    data.Scheduled = new Date().toISOString();
    await this.post(`${env.notifyUri}/${data.Type}/messages/send`, data).then(
      ({ data }) => data
    );

    return { ok: true };
  }
  public async GetProviders(): Promise<ProviderModel[]> {
    return await this.get<ProviderModel[]>(`${env.notifyUri}/Providers`).then(
      ({ data }) => data
    );
  }
  public async ValidateEmail(data: {
    To: string;
    Provider: string;
  }): Promise<any> { // eslint-disable-line
    return await this.post(
      `${env.notifyUri}/email/validate/complete`,
      data
    ).then(({ data }) => data);
  }
  public async BlacklistExists(data: { Address: string; MessageType: NotifyType  }): Promise<any> { // eslint-disable-line
    return await this.post(
      `${env.notifyUri}/messages/blacklist/exists`,
      data
    ).then(({ data }) => data);
  }
  public async RemoveBlacklist(data: {
    Address: string;
    MessageType: NotifyType;
  }) {
    // eslint-disable-line
    return await this.post(
      `${env.notifyUri}/messages/blacklist/remove`,
      data
    ).then(({ data }) => data);
  }
}
